import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { isEmpty } from 'lodash'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import { useMapWorkAreasFlag } from 'modules/locations/hooks/useMapWorkAreasFlag'
import { WorkAreaNodes } from 'modules/locations/hooks/useWorkArea'
import { useWorkAreaMaps } from 'modules/space_control/hooks/useWorkAreaMaps'

import ArchivedBox from './ArchivedBox'
import UnarchiveWorkAreasItem from './UnarchivedItems'

interface PropsWorkArea {
  locationId: number
  archivedWorkAreas: NonNullable<WorkAreaNodes>[]
  unArchivedWorkAreas: NonNullable<WorkAreaNodes>[]
}

const LocationWorkAreas = ({
  locationId,
  archivedWorkAreas,
  unArchivedWorkAreas,
}: PropsWorkArea) => {
  const hasMapWorkAreasFlag = useMapWorkAreasFlag()

  const allWorkAreaIds = [...unArchivedWorkAreas, ...archivedWorkAreas].map(
    (workArea) => workArea.id
  )
  const { workAreaMapsById } = useWorkAreaMaps({
    workAreaIds: allWorkAreaIds,
    skip: !hasMapWorkAreasFlag,
  })

  return (
    <Box>
      {!isEmpty(unArchivedWorkAreas) ? (
        <UnarchiveWorkAreasItem
          locationId={locationId}
          unarchiveWorkAreas={unArchivedWorkAreas}
          workAreaMapsById={workAreaMapsById}
        />
      ) : (
        <Box paddingBottom="s16">
          <Box
            width="full"
            paddingY="s32"
            paddingX="s32"
            border={{
              all: {
                color: 'grey400',
                width: 's1',
                style: 'solid',
              },
            }}
            borderRadius={{
              all: 'abs004',
            }}
            textAlign="center"
          >
            <Text size="300" weight="medium">
              {i18n.t('settings.locations.location.work_areas.empty_message')}
            </Text>
          </Box>
        </Box>
      )}

      {!isEmpty(archivedWorkAreas) && (
        <ArchivedBox locationId={locationId} archivedCount={archivedWorkAreas.length} />
      )}
    </Box>
  )
}

export default observer(LocationWorkAreas)
